import { cn } from '@theprintbar/shared';

interface ShippingTimeProps {
	title: string;
	text: string;
	bgColour: `bg-${string}`;
}

export function TimePill({ title, text, bgColour }: ShippingTimeProps) {
	return (
		<div
			className={cn(
				'lg:h-20 w-full flex flex-row gap-2 justify-between items-center rounded-[30px] py-2 px-4 lg:py-4 lg:px-8 border border-blue',
				bgColour || 'bg-blue-bright/20',
			)}
		>
			<p className="font-display font-light text-base lg:text-xl text-left">{title}</p>
			<p className="font-black font-gravity text-2xl lg:text-[40px] flex-1 break-words text-right uppercase mt-1">{text}</p>
		</div>
	);
}
